"use client";

import { Button } from "@/intent-components/ui/button";
import { IconMoon, IconSun } from "@intentui/icons";
import { switchColorScheme } from "./switch-color-schema.action";

export function DarkModeToggle() {
  return (
    <Button
      intent="outline"
      size="square-petite"
      aria-label="Switch theme"
      onPress={switchColorScheme}
    >
      <IconSun className="dark:-rotate-90 h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:scale-0" />
      <IconMoon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
    </Button>
  );
}
